import React, {Component} from 'react'
import styled from 'styled-components'
import FamilyMember from '../../dtos/FamilyMember'
import Offer from '../../dtos/Offer'
import CompleteSessionOffer from '../../views/groupsAndOffers/complete-sessions/CompleteSessionOffer'
import { borderColor } from '../colors'
import {addToCart, AddToCartResponse, getCurrentUser, getMembershipTemplateOffers} from '../requests'
import { FullWidth, ViewContainer } from '../styled-components/layout'
import LoadingOverlay from './LoadingOverlay'
import {ApplicationFlowContext} from "../../contexts/ApplicationFlowContextProvider";

const OfferContainer = styled(ViewContainer)`
  border-top: 1px solid ${borderColor};
  align-items: flex-start;
`;

const LoadingOverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  opacity: 0.75;
`;


interface IMembershipOffersProps {
  id: number
  selectedMemberId?: string
  refreshOptions?: () => void
  toggleShoppingButtonDisability: (val: boolean) => void
}

interface IMembershipOffersState {
  loading:             boolean
  offers:              Offer[]
  familyMembers:       Record<string, Partial<FamilyMember>> | undefined
  userId: number|null
  hasContact: boolean
}

export default class MembershipOffers extends Component<IMembershipOffersProps, IMembershipOffersState> {
  static contextType = ApplicationFlowContext
  state: IMembershipOffersState = {
    loading: false,
    offers: [],
    familyMembers: {},
    userId: null,
    hasContact: false,
  }

  static defaultProps = {
    refreshOptions: () => Promise.resolve(),
  }

  componentDidMount() {
    const {organizationId} = this.context;
    this.setState({
      loading: true
    })

    getCurrentUser()
      .then(user => {
        if (user && user.id) {
          this.setState({
            userId: user.id,
            hasContact: undefined !== user.contacts
              && undefined !== user.contacts.find((contact) => contact.organization_id === organizationId)
          })
        }
      })

    getMembershipTemplateOffers(this.props.id)
      .then(offers => {
        this.setState({
          loading: false,
          offers: offers.offers,
          familyMembers: offers.familyMembers
        })
      })
  }

  addSessionToCart = async (userId: number, planId: number, successMessage?: string): Promise<AddToCartResponse> => {
    this.setState({
      loading: true
    })
    this.props.toggleShoppingButtonDisability(true)
    const cartItem = await addToCart(userId, planId, {});
    // const {offers: returnedOffers} = await getSessionOffersForGroup(groupId, {redirectToLogin});
    // TODO: update offers?
    // setOffers(returnedOffers);
    await this.props.refreshOptions?.()
    this.setState({
      loading: false
    })
    this.props.toggleShoppingButtonDisability(false)
    return cartItem;
  }

  removeSessionFromCart = async (itemId: number) => {
    this.setState({
      loading: true
    })
    // await deleteCartItem(itemId, {});
    // const {offers: returnedOffers} = await getSessionOffersForGroup(groupId, {redirectToLogin});
    // setOffers(returnedOffers);
    this.setState({
      loading: false
    })
  }

  render() {
    const {
      selectedMemberId
    } = this.props
    const {organizationId} = this.context;

    if (this.state.loading) {
      return (
        <section>
          <LoadingOverlayContainer>
            <LoadingOverlay />
          </LoadingOverlayContainer>
        </section>
      )
    }

    return (
      <div>
        {
          this.state.familyMembers && (this.state.offers.map((offer, index) => (
            organizationId && this.state.userId && <FullWidth key={`offer-${index}`}>
              <OfferContainer>
                <CompleteSessionOffer
                  offer={offer}
                  familyMembers={this.state.familyMembers || {}}
                  selectedMemberId={selectedMemberId}
                  addSessionToCart={this.addSessionToCart}
                  removeSessionFromCart={this.removeSessionFromCart}
                  userId={this.state.userId}
                  organizationId={organizationId}
                  hasContact={this.state.hasContact}
                />
              </OfferContainer>
            </FullWidth>
        )))
        }
      </div>
    )
  }
}
